<template lang="html">

  <div id="contact" class="s-contact">

    <section class="contact-us">
      <div class="contact-intro">
        <span class="notch notch--lg notch--dark notch--bm"></span>
        <h2>contact us</h2>
        <p>We are happy to assist you with your project no matter what stage it is in. Please feel free to contact us for anything from a budget consultation to a request for proposal. We will answer any questions you might have about mobile touring or experiential marketing. Call us at 704-643-5550, or submit your info below to schedule a call or meeting.</p>
      </div>

      <form class="contact-form" @submit.prevent="save">
        <section class="cf__controls">
          <div class="cf__control">
            <input type="text" v-model="data.form.fields.first_name" placeholder="First Name">
          </div>
          <div class="cf__control">
            <input type="text" v-model="data.form.fields.last_name"  placeholder="Last Name">
          </div>
          <div class="cf__control">
            <input type="text" v-model="data.form.fields.phone"  placeholder="Phone">
          </div>
          <div class="cf__control">
            <input type="email" v-model="data.form.fields.email"  placeholder="Email">
          </div>
        </section>
        <div class="cf__control--btn">
          <button class="cf__button" type="submit">
            <span>submit</span>
          </button>
        </div>
      </form>

    </section>
  </div>

</template>

<script>
  export default {
    name: 'contact',
    data () {
      return {
        data: {
          form: {
            code: 'contact-form-1-jd4kBz',
            fields: {
              first_name: '',
              last_name: '',
              email: '',
              phone: ''
            }
          }
        }
      }
    },
    methods: {
      save () {
        this.$http.patch('form/' + this.data.form.code, this.data)
          .then(({ data }) => {
            console.log(data)
            alert(data.message)
          }, ({ data }) => {
            data && alert(data.message)
          })
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .s-contact {
    padding: 3rem 1rem;
    background: $white;
    @include breakpoint($md) {
      padding: 10rem 1rem 12rem 1rem;
      background: url('/static/images/truck-diagram-2-2x.png') no-repeat 1rem center;
      background-size: contain;
    }
  }

  .contact-us {
    margin: 0 auto;
    max-width: 47.500rem;
  }

  .contact-intro {
    text-align: center;
    h2 {
      color: $light-red;
    }
    p {
      text-align: left;
    }
  }

  .contact-form {
    width: 100%;
  }

  .cf__controls {
    display: grid;
    grid-template-columns: auto;
    grid-auto-rows: auto;
    grid-gap: 1.5rem;
    @include breakpoint($md) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .cf__control input {
    appearance: none;
    font-size: 0.9rem;
    line-height: 1;
    background-color: $lighter-gray;
    border: 1px solid $light-gray;
    padding: 1rem 0.5rem;
    width: 100%;
  }

  .cf__control--btn {
    text-align: center;
  }

</style>




// WEBPACK FOOTER //
// src/components/Contact.vue